import { render, staticRenderFns } from "./plugin-send.vue?vue&type=template&id=480aaca0&scoped=true&"
import script from "./plugin-send.vue?vue&type=script&lang=js&"
export * from "./plugin-send.vue?vue&type=script&lang=js&"
import style0 from "./plugin-send.vue?vue&type=style&index=0&id=480aaca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480aaca0",
  null
  
)

export default component.exports